import ReactMarkdown, { Options } from "react-markdown";
import rehypeKatex from "rehype-katex";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";

const replaceMathDelimiters = (text: string | null | undefined) => {
  if (!text) {
    return text;
  }
  return text
    .replace(/\\\(/g, "$")
    .replace(/\\\)/g, "$")
    .replace(/\\\[/g, "$$$$")
    .replace(/\\\]/g, "$$$$");
};

export const MarkdownContent = (
  options: Readonly<Options & { shouldReplaceMathDelimiter?: boolean }>,
) => {
  const content =
    options.shouldReplaceMathDelimiter === undefined ||
    options.shouldReplaceMathDelimiter === true
      ? replaceMathDelimiters(options.children)
      : options.children;

  return (
    <ReactMarkdown
      {...options}
      remarkPlugins={[remarkGfm, remarkMath]}
      rehypePlugins={[rehypeSanitize, rehypeKatex]}
    >
      {content}
    </ReactMarkdown>
  );
};
